import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-ink/50 text-center text-white" aria-label="Offerta a tempo limitato" data-id="element-212" data-mp="2sk46nkhn1yb1">
      <div className="h-1 w-full bg-gold" aria-hidden="true" data-id="element-213" data-mp="36bimjig91jdv" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-214" data-mp="31ipmh7vq6z84">
        <p className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[.16em] text-gold" data-id="element-215" data-mp="31h4o176aiw4z">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-216" data-mp="3g9yibyq81gtp" /> Il prezzo di lancio termina tra
        </p>
        <Countdown className="mt-5" data-id="element-217" data-mp="3p8tpbd13auy2" />
        <p className="mt-7 font-bold text-mist" data-id="element-218" data-mp="3p7s7mppkja7d">Dopo, il prezzo aumenta e non tornerà più così basso.</p>
      </div>
      <div className="h-1 w-full bg-gold" aria-hidden="true" data-id="element-219" data-mp="3l7q5ygju2gs3" />
    </section>;
}